import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TitleBlock = makeShortcode("TitleBlock");
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TitleBlock slots="heading" theme="light" className="titleBlock-align-left getting-started-title" mdxType="TitleBlock" />
    <h2 {...{
      "id": "getting-started-is-easy"
    }}>{`Getting started is easy.`}</h2>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" className="align-left horizontal-align ms-step-one" headerElementType="h2" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-1"
    }}>{`Step 1`}</h2>
    <p>{`Sign up for a free tier.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.adobe.com/go/powerautomate_getstarted"
        }}>{`Get started`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" variantsTypePrimary='secondary' variantStyleFill="outline" className="align-left horizontal-align ms-step-two" headerElementType="h2" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-2"
    }}>{`Step 2`}</h2>
    <p>{`Set up the connector.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://helpx.adobe.com/document-cloud/help/pdf-connector-for-microsoft-power-automate.html"
        }}>{`View instructions`}</a></li>
    </ul>
    <TextBlock slots="heading, text, buttons" width="33%" theme="light" variantsTypePrimary='secondary' variantStyleFill="outline" className="align-left horizontal-align ms-step-three" headerElementType="h2" mdxType="TextBlock" />
    <h2 {...{
      "id": "step-3"
    }}>{`Step 3`}</h2>
    <p>{`Pick a template to customize.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://powerautomate.microsoft.com/en-US/connectors/details/shared_adobepdftools/adobe-pdf-services/"
        }}>{`Browse templates`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      